module.exports = __webpack_public_path__ + "static/media/quinco_mental3.be0b856f.jpeg";